import { render, staticRenderFns } from "./GrupoTipoBaixaForm.vue?vue&type=template&id=7283cbb8"
import script from "./GrupoTipoBaixaForm.vue?vue&type=script&lang=js"
export * from "./GrupoTipoBaixaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports